import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';

// Native OS notification (Web Notifications API). Renders the system banner on
// macOS, the toast on Windows and the native style on Linux — the browser maps
// a single implementation to each OS. Fires alongside the audio alert so the
// visual and the sound share the exact same trigger and gating.

const NOTIFICATION_ICON = '/favicon-32x32.png';

const isNotificationSupported = () => 'Notification' in window;

export const hasDesktopNotificationPermission = () =>
  isNotificationSupported() && Notification.permission === 'granted';

// Asks for OS notification permission. Must be invoked from a user gesture
// (click/keypress), otherwise browsers silently ignore the request.
export const requestDesktopNotificationPermission = () => {
  if (!isNotificationSupported() || Notification.permission !== 'default') {
    return;
  }
  try {
    Notification.requestPermission().catch(() => {});
  } catch {
    // Older browsers expose only the callback signature; safe to ignore.
  }
};

const getStore = () => window.WOOT && window.WOOT.$store;

const getContactName = (store, message) => {
  const conversation = store?.getters?.getConversationById?.(
    message.conversation_id
  );
  return (
    conversation?.meta?.sender?.name || message?.sender?.name || 'Nuevo mensaje'
  );
};

const getNotificationBody = message => {
  if (message?.content) {
    return message.content;
  }
  if (message?.attachments?.length) {
    return '📎 Archivo adjunto';
  }
  return '';
};

const navigateToConversation = (store, conversationId) => {
  const accountId = store?.getters?.getCurrentAccountId;
  if (!accountId || !conversationId) {
    return;
  }
  const path = frontendURL(conversationUrl({ accountId, id: conversationId }));
  if (window.WOOT?.$router) {
    window.WOOT.$router.push(path);
  } else {
    window.location.href = path;
  }
};

export const showDesktopNotification = message => {
  if (!hasDesktopNotificationPermission()) {
    return;
  }
  try {
    const store = getStore();
    const conversationId = message?.conversation_id;

    const notification = new Notification(getContactName(store, message), {
      body: getNotificationBody(message),
      icon: NOTIFICATION_ICON,
      // Collapse repeated alerts from the same conversation into one banner.
      tag: `conversation-${conversationId}`,
      renotify: true,
    });

    notification.onclick = event => {
      event.preventDefault();
      window.focus();
      navigateToConversation(store, conversationId);
      notification.close();
    };
  } catch {
    // Ignore notification errors (blocked, unsupported, etc.).
  }
};
